import { Mode, Layout } from "./models/plot";
import i18n from "./i18n";

export interface PlotModeSelectBoxItem {
  id: Mode;
  name: string;
  image: string;
}
/** プロットモード */
export const plotModes: PlotModeSelectBoxItem[] = [
  {
    id: Mode.kishoutenketsu,
    name: i18n.t('plotPage.modes.kishoutenketsu') as string,
    image: "none",
  },
  {
    id: Mode.johakyu,
    name: i18n.t('plotPage.modes.johakyu') as string,
    image: "none",
  },
  {
    id: Mode.custom,
    name: i18n.t('plotPage.modes.custom') as string,
    image: "none",
  },
];

export interface PlotLayoutSelectBoxItem {
  id: Layout;
  name: string;
}
/** プロットレイアウト */
export const plotLayouts: PlotLayoutSelectBoxItem[] = [
  {
    id: Layout.simple,
    name: i18n.t('plotPage.layouts.simple') as string,
  },
  {
    id: Layout.detail,
    name: i18n.t('plotPage.layouts.detail') as string,
  },
];

export interface ChildPlotItem {
  plotId: String;
  name: string;
  image: "none";
}

export interface NewChildPlotItem extends ChildPlotItem {
  mode: PlotModeSelectBoxItem;
}
